import "./main.css"
import React from "react"
import ReactTooltip, { TooltipProps } from "react-tooltip"

interface Props extends TooltipProps {
	id: string
}

/**
 * ### Known Issues
 * It seems that tooltip sometimes has a random position on the screen,
 * but it also seems that it is not because it is instead of `ClassProvider`.
 */
const Tooltip = ({ ...props }: Props) => {
	return <ReactTooltip effect="solid" className="DefaultTooltip-tooltip tooltip-html" {...props} />
}

export default Tooltip
